import MenuPopover from 'src/components/menu_popover/menu_popover.vue'

import {
  offeredScopes,
  visibilityIcon,
} from 'src/services/status_visibility/status_visibility.js'

// The scope picker: one labelled button and a menu of the scopes the post
// form offers (see offeredScopes).
const ScopeMenu = {
  components: { MenuPopover },
  props: {
    showAll: { type: Boolean, required: true },
    userDefault: { type: String, required: true },
    // the replied-to post's scope
    originalScope: { type: String, required: false },
    initialScope: { type: String, required: false },
    // the menu stays inside the closest element matching this
    within: { type: String, default: '.composer-box' },
  },
  emits: ['change'],
  data() {
    return {
      currentScope: this.initialScope,
    }
  },
  computed: {
    scopes() {
      return offeredScopes(this)
    },
    showNothing() {
      return this.scopes.length === 0
    },
    items() {
      return this.scopes.map((scope) => ({
        key: scope,
        label: this.$t(`general.scope_in_timeline.${scope}`),
        description: this.$t(`post_status.scope_description.${scope}`),
        icon: this.icon(scope),
        radio: true,
        mark: false,
        checked: scope === this.currentScope,
        action: () => this.changeVis(scope),
      }))
    },
  },
  methods: {
    icon: visibilityIcon,
    changeVis(scope) {
      this.currentScope = scope
      this.$emit('change', scope)
    },
  },
  watch: {
    originalScope(newVal) {
      this.currentScope = newVal
    },
  },
}

export default ScopeMenu
